(function ($) {
  $(function () {
    var $siteHeader = $('.site-header.is-sticky');

    if ($siteHeader.length) {
      $(window).on('scroll', function () {
        $siteHeader.toggleClass('navbar-fixed-top', $(this).scrollTop() > 1);
      });
    }

    var scrollToTop = document.querySelector('.scroll-to-top');

    if (scrollToTop) {
      var scrollTicking = false;

      var updateScrollToTop = function () {
        var shouldShow = window.scrollY > Math.max(320, window.innerHeight * 0.5);
        scrollToTop.classList.toggle('show', shouldShow);
        scrollToTop.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
        scrollToTop.setAttribute('tabindex', shouldShow ? '0' : '-1');
        scrollTicking = false;
      }; 

      window.addEventListener('scroll', function () {
        if (!scrollTicking) {
          window.requestAnimationFrame(updateScrollToTop);
          scrollTicking = true;
        }
      }, { passive: true });

      window.addEventListener('resize', updateScrollToTop);
      updateScrollToTop();

      scrollToTop.addEventListener('click', function () {
        window.scrollTo({
          top: 0,
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
        });
      });
    }

    var mobileMenu = document.querySelector('[data-mobile-menu]');
    var menuButton = document.querySelector('[data-mobile-menu-open]');
    var menuPanel = mobileMenu ? mobileMenu.querySelector('.mobile-menu-panel') : null;
    var closeButtons = mobileMenu ? mobileMenu.querySelectorAll('[data-mobile-menu-close]') : [];
    var navIcon = document.querySelector('#nav-icon');
    var lastFocusedElement = null;

    if (mobileMenu && menuButton && menuPanel) {
      var getFocusableElements = function () {
        return Array.prototype.slice.call(menuPanel.querySelectorAll(
          'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
        )).filter(function (element) {
          return element.offsetParent !== null;
        });
      };

      var closeMenu = function (restoreFocus) {
        if (!mobileMenu.classList.contains('is-open')) {
          return;
        }

        mobileMenu.classList.remove('is-open');
        mobileMenu.setAttribute('aria-hidden', 'true');
        menuButton.setAttribute('aria-expanded', 'false');
        document.body.classList.remove('mobile-menu-open');

        if (navIcon) {
          navIcon.classList.remove('open-custom-menu');
        }

        if (restoreFocus !== false && lastFocusedElement) {
          lastFocusedElement.focus();
        }
      };

      var openMenu = function () {
        lastFocusedElement = document.activeElement;
        mobileMenu.classList.add('is-open');
        mobileMenu.setAttribute('aria-hidden', 'false');
        menuButton.setAttribute('aria-expanded', 'true');
        document.body.classList.add('mobile-menu-open');

        if (navIcon) {
          navIcon.classList.add('open-custom-menu');
        }

        window.requestAnimationFrame(function () {
          var focusableElements = getFocusableElements();

          if (focusableElements.length) {
            focusableElements[0].focus();
          }
        });
      };

      menuPanel.querySelectorAll('.menu-item-has-children').forEach(function (menuItem, index) {
        var submenu = Array.prototype.find.call(menuItem.children, function (child) {
          return child.classList && child.classList.contains('sub-menu');
        });
        var link = Array.prototype.find.call(menuItem.children, function (child) {
          return child.tagName === 'A';
        });

        if (!submenu || !link) {
          return;
        }

        var submenuId = 'mobile-submenu-' + index;
        var toggle = document.createElement('button');
        submenu.id = submenuId;
        toggle.type = 'button';
        toggle.className = 'mobile-submenu-toggle';
        toggle.setAttribute('aria-expanded', 'false');
        toggle.setAttribute('aria-controls', submenuId);
        toggle.setAttribute('aria-label', 'Untermenü öffnen: ' + link.textContent.trim());
        toggle.innerHTML = '<span aria-hidden="true"></span>';
        link.insertAdjacentElement('afterend', toggle);

        toggle.addEventListener('click', function () {
          var isOpen = menuItem.classList.toggle('is-submenu-open');
          toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
          toggle.setAttribute('aria-label', (isOpen ? 'Untermenü schließen: ' : 'Untermenü öffnen: ') + link.textContent.trim());
        });
      });

      menuButton.addEventListener('click', openMenu);

      Array.prototype.forEach.call(closeButtons, function (button) {
        button.addEventListener('click', function () {
          closeMenu(true);
        });
      });

      mobileMenu.addEventListener('click', function (event) {
        if (event.target.closest('a') && !event.target.closest('.mobile-submenu-toggle')) {
          closeMenu(false);
        }
      });

      document.addEventListener('keydown', function (event) {
        if (!mobileMenu.classList.contains('is-open')) {
          return;
        }

        if (event.key === 'Escape') {
          event.preventDefault();
          closeMenu(true);
          return;
        }

        if (event.key === 'Tab') {
          var focusableElements = getFocusableElements();
          var firstElement = focusableElements[0];
          var lastElement = focusableElements[focusableElements.length - 1];

          if (!focusableElements.length) {
            event.preventDefault();
          } else if (event.shiftKey && document.activeElement === firstElement) {
            event.preventDefault();
            lastElement.focus();
          } else if (!event.shiftKey && document.activeElement === lastElement) {
            event.preventDefault();
            firstElement.focus();
          }
        }
      });

      $(window).on('resize', function () {
        if (window.innerWidth > 997) {
          closeMenu(false);
        }
      });
    }
  });
})(jQuery);
